import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Form from './Form';
import { save, reset } from '../../actions/LiveInterviewReview/save';
import { retrieve as retrieveReview } from '../../actions/LiveInterviewReview/show';
import { retrieve } from '../../actions/LiveInterview/show';
import { del } from '../../actions/LiveInterviewReview/delete';
import {getReviewScales, reset as resetReviewScales} from "../../actions/ReviewScale/show";
import {getReviewCriteria} from "../../utils/reviewScales";

class LiveInterviewReviewEdit extends Component {
  static propTypes = {
    error: PropTypes.string,
    interviewLoading: PropTypes.bool.isRequired,
    reviewLoading: PropTypes.bool.isRequired,
    reviewSaveLoading: PropTypes.bool.isRequired,
    deleteLoading: PropTypes.bool.isRequired,
    interview: PropTypes.object,
    review: PropTypes.object,
    savedReview: PropTypes.object,
    deletedReview: PropTypes.object,
    updateReview: PropTypes.func.isRequired,
    deleteReview: PropTypes.func.isRequired,
  };
  componentDidMount() {
    this.props.getReviewScales();
    this.props.retrieveInterview(decodeURIComponent(this.props.match.params.interview));
    this.props.retrieveReview(decodeURIComponent(this.props.match.params.review));
  }

  componentWillUnmount() {
    this.props.reset();
  }

  del = () => {
    if (window.confirm('Are you sure you want to delete this item?'))
      this.props.deleteReview(this.props.review);
  };

  render() {
    if (this.props.savedReview)
      this.props.history.push({
        pathname: `../reviews`,
        state: {successMessage: 'Review successfully updated.'}
      });

    if (this.props.deletedReview)
      this.props.history.push({
        pathname: `../reviews`,
        state: {successMessage: 'Review successfully deleted.'}
      });

    return (
      <div>
        {this.props.interview && (
          <h2 className="mb-3">Edit Review of "{this.props.interview.title}" Live Interview.</h2>
        )}

        {(this.props.interviewLoading ||
          this.props.reviewLoading ||
          this.props.reviewSaveLoading ||
          this.props.deleteLoading) && (
          <div className="alert alert-info" role="status">
            Loading...
          </div>
        )}
        {this.props.error && (
          <div className="alert alert-danger" role="alert">
            <span className="fa fa-exclamation-triangle" aria-hidden="true" />{' '}
            {this.props.error}
          </div>
        )}
        {!this.props.reviewLoading && !this.props.interviewLoading && this.props.review &&
         !this.props.criteriaLoading && this.props.modifiedCriteria && (
          <Form
            onSubmit={this.props.updateReview}
            initialValues={{...{}, ...this.props.review}}
            reviewCriteria={getReviewCriteria(this.props.modifiedCriteria)}
          />
        )}
        {this.props.review && (
          <button onClick={this.del} type="button" className="btn btn-danger mr-3 mb-3">Delete</button>
        )}
        <Link to={`../../../live-interviews/show/${this.props.match.params.interview}`} className="btn btn-primary mr-3 mb-3">
          Back to Interview
        </Link>
        <Link to="../reviews" className="btn btn-primary mb-3">
          Back to All Reviews
        </Link>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const interviewLoading = state.liveinterview.show.loading;
  const reviewLoading = state.liveinterviewreview.list.loading;
  const reviewSaveLoading = state.liveinterviewreview.save.loading;
  const deleteLoading = state.liveinterviewreview.del.loading;
  const error = state.liveinterview.show.error || state.liveinterviewreview.list.error || state.liveinterviewreview.save.error || state.liveinterviewreview.del.error;
  const interview = state.liveinterview.show.retrieved;
  const savedReview = state.liveinterviewreview.save.saved;
  const deletedReview = state.liveinterviewreview.del.deleted;
  const review = state.liveinterviewreview.show.retrieved;

  return {
    interviewLoading,
    reviewLoading,
    reviewSaveLoading,
    deleteLoading,
    error,
    interview,
    savedReview,
    review,
    deletedReview,
    modifiedCriteria: state.reviewScale.show.criteria,
    criteriaLoading: state.reviewScale.show.loading,
  };
};

const mapDispatchToProps = dispatch => ({
  retrieveReview: (id) => dispatch(retrieveReview(id)),
  getReviewScales: () => dispatch(getReviewScales()),
  updateReview: values => dispatch(save(values, values['@id'], 'PUT')),
  deleteReview: review => dispatch(del(review)),
  retrieveInterview: (id) => dispatch(retrieve(id)),
  reset: () => {
    dispatch(reset());
    dispatch(resetReviewScales());
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LiveInterviewReviewEdit);
